"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var e = require("react"),
  t = require("@babel/runtime/helpers/extends"),
  n = require("@react-spring/web"),
  r = require("react-use-gesture"),
  i = require("@babel/runtime/helpers/defineProperty"),
  a = require("@babel/runtime/helpers/objectWithoutProperties"),
  l = require("styled-components"),
  o = require("react-dom");
function s(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function c(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function () {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var u = c(e),
  d = s(t),
  g = s(i),
  f = s(a),
  p = s(l),
  m = s(o);
const h = e => {
    var _r$current;
    let _e$currentTranslate = _slicedToArray(e.currentTranslate, 2),
      t = _e$currentTranslate[0],
      n = _e$currentTranslate[1],
      r = e.imageRef,
      i = e.pinchDelta,
      a = e.scale,
      _e$touchOrigin = _slicedToArray(e.touchOrigin, 2),
      l = _e$touchOrigin[0],
      o = _e$touchOrigin[1];
    if (!(r !== null && r !== void 0 && r.current)) return [0, 0];
    const _r$current$getBoundin = (_r$current = r.current) === null || _r$current === void 0 ? void 0 : _r$current.getBoundingClientRect(),
      s = _r$current$getBoundin.height,
      c = _r$current$getBoundin.left,
      u = _r$current$getBoundin.top,
      d = _r$current$getBoundin.width;
    return [-((l - c - d / 2) / a) * i + t, -((o - u - s / 2) / a) * i + n];
  },
  v = e => {
    var _e$current;
    if (!e.current) return !1;
    const _e$current$getBoundin = (_e$current = e.current) === null || _e$current === void 0 ? void 0 : _e$current.getBoundingClientRect(),
      t = _e$current$getBoundin.bottom,
      n = _e$current$getBoundin.left,
      r = _e$current$getBoundin.right,
      i = _e$current$getBoundin.top,
      _window = window,
      a = _window.innerHeight,
      l = _window.innerWidth;
    return n > .5 * l || i > .5 * a || r < .5 * l || t < .5 * a;
  },
  y = ["style"];
function b(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? b(Object(n), !0).forEach(function (t) {
      g.default(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
const O = {
    pinching: !1,
    scale: 1,
    translateX: 0,
    translateY: 0
  },
  E = t => {
    let i = t.imgProps.style,
      a = t.inline,
      l = t.isCurrentImage,
      o = t.pagerHeight,
      s = t.pagerIsDragging,
      c = t.setDisableDrag,
      g = t.singleClickToZoom,
      p = f.default(t.imgProps, y);
    const _e$useState = e.useState(!1),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      m = _e$useState2[0],
      b = _e$useState2[1],
      E = e.useRef(null),
      _n$useSpring = n.useSpring(() => w(w({}, O), {}, {
        onChange: (e, t) => {
          (e.value.scale < 1 || !e.value.pinching) && t.start(O), e.value.scale > 1 && v(E) && t.start(O);
        },
        onRest: (e, t) => {
          1 === e.value.scale && (t.start(O), c(!1));
        }
      })),
      _n$useSpring2 = _slicedToArray(_n$useSpring, 2),
      _n$useSpring2$ = _n$useSpring2[0],
      C = _n$useSpring2$.scale,
      P = _n$useSpring2$.translateX,
      j = _n$useSpring2$.translateY,
      k = _n$useSpring2[1];
    return e.useEffect(() => {
      l || 1 === C.get() || k.start(O);
    }, [l, C, k]), r.useGesture({
      onDrag: e => {
        let t = e.cancel,
          n = e.first,
          _e$memo = e.memo,
          r = _e$memo === void 0 ? {
            initialTranslateX: 0,
            initialTranslateY: 0
          } : _e$memo,
          _e$movement = _slicedToArray(e.movement, 2),
          i = _e$movement[0],
          a = _e$movement[1],
          l = e.pinching,
          o = e.tap,
          c = e.touches;
        if (!(s || 1 === C.get() || o || (i && a && !m && b(!0), c > 1 || l || C.get() <= 1))) return C.get() > 1 && v(E) ? void t() : n ? {
          initialTranslateX: P.get(),
          initialTranslateY: j.get()
        } : (k.start({
          translateX: r.initialTranslateX + i,
          translateY: r.initialTranslateY + a
        }), r);
      },
      onDragEnd: e => {
        let t = e.memo;
        void 0 !== t && setTimeout(() => b(!1), 100);
      },
      onPinch: e => {
        let t = e.cancel,
          n = e.ctrlKey,
          r = e.event,
          i = e.last,
          _e$movement2 = _slicedToArray(e.movement, 1),
          a = _e$movement2[0],
          _e$origin = _slicedToArray(e.origin, 2),
          l = _e$origin[0],
          o = _e$origin[1];
        if (s) return;
        if (c(!0), a && !m && b(!0), i) return void t();
        const u = n ? 1e3 : 250,
          d = C.get() + a / u,
          g = d - C.get();
        let f = [l, o];
        "clientX" in r && "clientY" in r && n && (f = [r.clientX, r.clientY]);
        const _h = h({
            currentTranslate: [P.get(), j.get()],
            imageRef: E,
            pinchDelta: g,
            scale: C.get(),
            touchOrigin: f
          }),
          _h2 = _slicedToArray(_h, 2),
          p = _h2[0],
          v = _h2[1];
        d < .5 ? k.start({
          pinching: !0,
          scale: .5
        }) : d > 3 ? k.start({
          pinching: !0,
          scale: 3
        }) : k.start({
          pinching: !0,
          scale: d,
          translateX: p,
          translateY: v
        });
      },
      onPinchEnd: () => {
        s || (C.get() > 1 ? c(!0) : k.start(O), setTimeout(() => b(!1), 100));
      }
    }, {
      domTarget: E,
      drag: {
        filterTaps: !0
      },
      enabled: !a,
      eventOptions: {
        passive: !1
      }
    }), (t => {
      let _t$enabled = t.enabled,
        n = _t$enabled === void 0 ? !0 : _t$enabled,
        _t$latency = t.latency,
        r = _t$latency === void 0 ? 300 : _t$latency,
        _t$onDoubleClick = t.onDoubleClick,
        i = _t$onDoubleClick === void 0 ? () => null : _t$onDoubleClick,
        _t$onSingleClick = t.onSingleClick,
        a = _t$onSingleClick === void 0 ? () => null : _t$onSingleClick,
        l = t.ref;
      e.useEffect(() => {
        const e = l.current;
        let t,
          o = 0;
        const s = e => {
          n && (o += 1, t = setTimeout(() => {
            1 === o ? a(e) : 2 === o && i(e), o = 0;
          }, r));
        };
        return e !== null && e !== void 0 && e.addEventListener("click", s), () => {
          e !== null && e !== void 0 && e.removeEventListener("click", s), t && clearTimeout(t);
        };
      });
    })({
      [g ? "onSingleClick" : "onDoubleClick"]: e => {
        if (s || m) return void e.stopPropagation();
        if (1 !== C.get()) return void k.start(O);
        const t = e.clientX,
          n = e.clientY,
          r = C.get() + 1,
          i = r - C.get(),
          _h3 = h({
            currentTranslate: [P.get(), j.get()],
            imageRef: E,
            pinchDelta: i,
            scale: C.get(),
            touchOrigin: [t, n]
          }),
          _h4 = _slicedToArray(_h3, 2),
          a = _h4[0],
          l = _h4[1];
        c(!0), k.start({
          pinching: !0,
          scale: r,
          translateX: a,
          translateY: l
        });
      },
      enabled: !a,
      latency: g ? 0 : 200,
      ref: E
    }), u.default.createElement(x, d.default({
      $inline: a,
      className: "lightbox-image",
      draggable: "false",
      onClick: e => {
        e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
      },
      onDragStart: e => {
        e.preventDefault();
      },
      ref: E,
      style: w(w({}, i), {}, {
        maxHeight: o,
        transform: n.to([C, P, j], (e, t, n) => `translate(${t}px, ${n}px) scale(${e})`)
      }, l && {
        willChange: "transform"
      })
    }, p));
  };
E.displayName = "Image";
const x = p.default(n.animated.img)`
    width: auto;
    height: auto;
    max-width: 100%;
    user-select: none;
    touch-action: ${e => {
    let t = e.$inline;
    return t ? "pan-y" : "none";
  }};
    ::selection {
        background: none;
    }
`,
  C = t => {
    let i = t.currentIndex,
      a = t.images,
      l = t.imageStageHeight,
      o = t.imageStageWidth,
      s = t.inline,
      c = t.onClose,
      g = t.onNext,
      f = t.onPrev,
      p = t.renderImageOverlay,
      m = t.singleClickToZoom;
    const h = e.useRef(!0),
      _e$useState3 = e.useState(!1),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      v = _e$useState4[0],
      y = _e$useState4[1],
      _e$useState5 = e.useState("100%"),
      _e$useState6 = _slicedToArray(_e$useState5, 2),
      b = _e$useState6[0],
      w = _e$useState6[1],
      _e$useState7 = e.useState(!1),
      _e$useState8 = _slicedToArray(_e$useState7, 2),
      O = _e$useState8[0],
      x = _e$useState8[1];
    e.useEffect(() => {
      const e = s ? l : l - 50;
      e !== b && w(e);
    }, [s, b, l]);
    const C = u.default.useCallback(function (e) {
        const t = (e - i) * o + (arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0 : 0);
        return e < i - 1 || e > i + 1 ? {
          display: "none",
          x: t
        } : {
          display: "flex",
          x: t
        };
      }, [i, o]),
      _n$useSprings = n.useSprings(a.length, e => C(e)),
      _n$useSprings2 = _slicedToArray(_n$useSprings, 2),
      I = _n$useSprings2[0],
      $ = _n$useSprings2[1];
    e.useEffect(() => {
      h.current ? h.current = !1 : $.start(e => C(e));
    }, [i, C, $]);
    const N = r.useGesture({
      onDrag: e => {
        let t = e.active,
          n = e.cancel,
          _e$direction = _slicedToArray(e.direction, 1),
          r = _e$direction[0],
          i = e.distance,
          a = e.down,
          _e$movement3 = _slicedToArray(e.movement, 1),
          l = _e$movement3[0],
          s = e.tap,
          c = e.touches,
          u = e.velocity;
        if (v || 0 === l || s) return;
        O || x(!0);
        const d = Math.abs(r) > .7;
        if ((a && d && i > o / 3.5 || a && d && u > 2) && t) {
          const e = r > 0 ? -1 : 1;
          return n(), void (e > 0 ? g() : e < 0 && f());
        }
        c > 1 ? n() : $.start(e => C(e, a, l));
      },
      onDragEnd: () => {
        O && ($.start(e => C(e)), setTimeout(() => x(!1), 100));
      },
      onWheel: e => {
        let t = e.ctrlKey,
          _e$direction2 = _slicedToArray(e.direction, 2),
          n = _e$direction2[0],
          r = _e$direction2[1],
          i = e.velocity;
        if (t || v || 0 === i) return;
        O || x(!0);
        if (i > 1.1) {
          const e = n + r > 0 ? -1 : 1;
          e > 0 ? g() : e < 0 && f();
        }
      },
      onWheelEnd: () => {
        $.start(e => C(e)), setTimeout(() => x(!1), 100);
      }
    }, {
      drag: {
        filterTaps: !0
      },
      wheel: {
        enabled: !s
      }
    });
    return u.default.createElement(P, null, I.map((e, t) => {
      let n = e.display,
        r = e.x;
      return u.default.createElement(D, d.default({
        $inline: s
      }, N(), {
        className: "lightbox-image-pager",
        key: t,
        onClick: () => {
          if (c) return Math.abs(r.get()) < 1 && !v && c();
        },
        role: "presentation",
        style: {
          display: n,
          transform: r.to(e => `translateX(${e}px)`)
        }
      }), u.default.createElement(k, null, u.default.createElement(j, null, u.default.createElement(T, {
        $inline: s,
        onClick: e => {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        }
      }, u.default.createElement(E, {
        imgProps: a[t],
        inline: s,
        isCurrentImage: t === i,
        pagerHeight: b,
        pagerIsDragging: O,
        setDisableDrag: y,
        singleClickToZoom: m
      }), p()))));
    }));
  };
C.displayName = "ImagePager";
const P = p.default.div`
    height: 100%;
    width: 100%;
`,
  j = p.default.div`
    display: flex;
    justify-content: center;
    align-items: center;
`,
  k = p.default.div`
    width: 100%;
    display: flex;
    justify-content: center;
`,
  D = p.default(n.animated.span)`
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 100%;
    width: 100%;
    will-change: transform;
    touch-action: ${e => {
    let t = e.$inline;
    return t ? "pan-y" : "none";
  }};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`,
  T = p.default.div`
    position: relative;
    touch-action: ${e => {
    let t = e.$inline;
    return t ? "pan-y" : "none";
  }};
    user-select: none;
    display: flex;
    justify-content: center;
    width: 100%;
`,
  I = e => {
    let t = e.currentIndex,
      n = e.images;
    return u.createElement($, null, n.map((e, n) => {
      let r = e.alt,
        i = e.src;
      return u.createElement(N, {
        $isCurrentImage: n === t,
        alt: r,
        key: `${r}-${i}-${n}`,
        src: i
      });
    }));
  },
  $ = p.default.div`
    width: 100%;
    height: inherit;
`,
  N = p.default.img`
    ${e => {
    let t = e.$isCurrentImage;
    return !t && l.css`
            visibility: hidden;
            display: none;
        `;
  }}
    height:100%;
    width: 100%;
    object-fit: contain;
`,
  S = t => {
    let _t$className = t.className,
      n = _t$className === void 0 ? "" : _t$className,
      r = t.currentIndex,
      i = t.images,
      a = t.inline,
      l = t.onClose,
      o = t.onNext,
      s = t.onPrev,
      c = t.renderImageOverlay,
      d = t.renderNextButton,
      g = t.renderPrevButton,
      f = t.singleClickToZoom;
    const p = r > 0,
      m = r + 1 < i.length,
      h = m ? o : () => null,
      v = p ? s : () => null,
      _ref = ((_t$current, _t$current2) => {
        const t = e.useRef(null),
          _e$useState9 = e.useState(null),
          _e$useState10 = _slicedToArray(_e$useState9, 2),
          n = _e$useState10[0],
          r = _e$useState10[1],
          _e$useState11 = e.useState({
            height: ((_t$current = t.current) === null || _t$current === void 0 ? void 0 : _t$current.clientHeight) || 0,
            width: ((_t$current2 = t.current) === null || _t$current2 === void 0 ? void 0 : _t$current2.clientWidth) || 0
          }),
          _e$useState12 = _slicedToArray(_e$useState11, 2),
          i = _e$useState12[0],
          a = _e$useState12[1],
          l = e.useCallback(e => {
            null !== e && (r(e), a({
              height: e.clientHeight,
              width: e.clientWidth
            }));
          }, []);
        return e.useEffect(() => {
          const e = () => {
            if (n) {
              const e = n.clientHeight,
                t = n.clientWidth;
              e === i.height && t === i.width || a({
                height: e,
                width: t
              });
            }
          };
          return window.addEventListener("resize", e), window.addEventListener("orientationchange", e), () => {
            window.removeEventListener("resize", e), window.removeEventListener("orientationchange", e);
          };
        }, [n, i.height, i.width]), [i, l];
      })(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      y = _ref2$.height,
      b = _ref2$.width,
      w = _ref2[1];
    return u.default.createElement(L, {
      className: n,
      "data-testid": "lightbox-image-stage",
      ref: w
    }, g({
      canPrev: p
    }), b ? u.default.createElement(C, {
      currentIndex: r,
      images: i,
      imageStageHeight: y,
      imageStageWidth: b,
      inline: a,
      onClose: l,
      onNext: h,
      onPrev: v,
      renderImageOverlay: c,
      singleClickToZoom: f
    }) : a ? u.default.createElement(I, {
      currentIndex: r,
      images: i
    }) : null, d({
      canNext: m
    }));
  },
  L = p.default.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
function W(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function X(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? W(Object(n), !0).forEach(function (t) {
      g.default(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
const H = e => {
    let t = e.children,
      r = e.className,
      i = e.isOpen,
      a = e.pageTransitionConfig,
      l = e.style;
    const o = {
        config: X(X({}, n.config.default), {}, {
          friction: 32,
          mass: 1,
          tension: 320
        }),
        enter: {
          opacity: 1,
          transform: "scale(1)"
        },
        from: {
          opacity: 0,
          transform: "scale(0.75)"
        },
        leave: {
          opacity: 0,
          transform: "scale(0.75)"
        }
      },
      s = n.useTransition(i, X(X({}, o), a));
    return u.default.createElement(u.default.Fragment, null, s((e, n) => n && u.default.createElement(Y, {
      className: "lightbox-container" + (r ? ` ${r}` : ""),
      "data-testid": "lightbox-container",
      style: X(X({}, e), l)
    }, t)));
  },
  Y = p.default(n.animated.div)`
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 400;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;
class R extends u.default.Component {
  constructor() {
    super(...arguments), g.default(this, "portalContainer", void 0), g.default(this, "body", void 0), g.default(this, "preventWheel", e => e.preventDefault());
  }
  componentDidMount() {
    this.body = document.body, this.portalContainer = document.createElement("div"), this.portalContainer.setAttribute("class", "lightbox-portal"), this.body.appendChild(this.portalContainer), this.forceUpdate(), this.portalContainer.addEventListener("wheel", this.preventWheel);
  }
  componentWillUnmount() {
    this.portalContainer.removeEventListener("wheel", this.preventWheel), this.body.removeChild(this.portalContainer);
  }
  render() {
    if (void 0 === this.portalContainer) return null;
    const e = this.props.children;
    return u.default.createElement(u.default.Fragment, null, m.default.createPortal(e, this.portalContainer));
  }
}
module.exports = t => {
  let _t$className2 = t.className,
    n = _t$className2 === void 0 ? "" : _t$className2,
    r = t.currentIndex,
    _t$images = t.images,
    i = _t$images === void 0 ? [] : _t$images,
    _t$inline = t.inline,
    a = _t$inline === void 0 ? !1 : _t$inline,
    l = t.isOpen,
    o = t.onClose,
    s = t.onNext,
    c = t.onPrev,
    _t$pageTransitionConf = t.pageTransitionConfig,
    d = _t$pageTransitionConf === void 0 ? null : _t$pageTransitionConf,
    _t$renderFooter = t.renderFooter,
    g = _t$renderFooter === void 0 ? () => null : _t$renderFooter,
    _t$renderHeader = t.renderHeader,
    f = _t$renderHeader === void 0 ? () => null : _t$renderHeader,
    _t$renderImageOverlay = t.renderImageOverlay,
    p = _t$renderImageOverlay === void 0 ? () => null : _t$renderImageOverlay,
    _t$renderNextButton = t.renderNextButton,
    m = _t$renderNextButton === void 0 ? () => null : _t$renderNextButton,
    _t$renderPrevButton = t.renderPrevButton,
    h = _t$renderPrevButton === void 0 ? () => null : _t$renderPrevButton,
    _t$singleClickToZoom = t.singleClickToZoom,
    v = _t$singleClickToZoom === void 0 ? !1 : _t$singleClickToZoom,
    _t$style = t.style,
    y = _t$style === void 0 ? {} : _t$style;
  e.useEffect(() => {
    const e = e => {
        l && ["ArrowUp", "ArrowDown", "End", "Home", "PageUp", "PageDown"].includes(e.key) && e.preventDefault();
      },
      t = e => {
        if (l) switch (e.key) {
          case "ArrowLeft":
            c();
            break;
          case "ArrowRight":
            s();
            break;
          case "Escape":
            o && o();
            break;
          default:
            e.preventDefault();
        }
      };
    return document.addEventListener("keyup", t), document.addEventListener("keydown", e), () => {
      document.removeEventListener("keyup", t), document.removeEventListener("keydown", e);
    };
  });
  const b = u.default.createElement(S, {
    currentIndex: r,
    images: i,
    inline: a,
    onClose: o,
    onNext: s,
    onPrev: c,
    renderImageOverlay: p,
    renderNextButton: m,
    renderPrevButton: h,
    singleClickToZoom: v
  });
  return a ? b : u.default.createElement(R, null, u.default.createElement(H, {
    className: n,
    isOpen: l,
    pageTransitionConfig: d,
    style: y
  }, f(), b, g()));
};